<template>
<div class="filters-container">
    <p class="filters-container__title">Make</p>
    <button class="btn" @click="setBrand('peugeot')">Peugeot</button>
    <button class="btn" @click="setBrand('citroen')">Citroën</button>
</div>
</template>

<script>
export default {

    methods: {
        setBrand(brand) {
            this.$store.dispatch('BusinessResults/updateParamsAndPush', { brand });
        }
    }

}
</script>

<style lang="scss" scoped >
    @import '../../../sass/redesign/_variables.scss';

    .filters-container {
        box-shadow: $default-card-box-shadow;
        border-radius: $default-card-border-radius;
        border-top-left-radius: $default-card-border-radius;
        border-top-right-radius: $default-card-border-radius;
        border-top: 10px solid $blue;
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        padding: 0.5rem;
    }
</style>